import emailjs from "@emailjs/browser";
import cvData from "../data/cv";
import { devError } from "../utils/devLog";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID?.trim();
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID?.trim();
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim();

const THROTTLE_MS = 5 * 60 * 1000;
const throttleCache = new Map();

const errorText = (error) =>
  error?.message || error?.text || error?.toString?.() || "Unknown error";

const formatParams = (params) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value != null && value !== ""
  );
  if (entries.length === 0) {
    return "";
  }
  return entries.map(([key, value]) => `${key}: ${value}`).join("\n");
};

const buildMessage = (error, { source, fatal, params }) => {
  const lines = [
    "An error occurred on the portfolio site.",
    "",
    `Source: ${source}`,
    `Fatal: ${fatal ? "yes" : "no"}`,
    `Time: ${new Date().toISOString()}`,
    `Page: ${typeof window !== "undefined" ? window.location.href : "unknown"}`,
    "",
    `Error: ${errorText(error)}`,
  ];

  const paramsBlock = formatParams(params);
  if (paramsBlock) {
    lines.push("", "Details:", paramsBlock);
  }

  if (typeof navigator !== "undefined" && navigator.userAgent) {
    lines.push("", `User agent: ${navigator.userAgent}`);
  }

  return lines.join("\n");
};

const shouldThrottle = (source, error) => {
  const key = `${source}:${errorText(error).slice(0, 120)}`;
  const now = Date.now();
  const lastSent = throttleCache.get(key);
  if (lastSent != null && now - lastSent < THROTTLE_MS) {
    return true;
  }
  throttleCache.set(key, now);
  return false;
};

export const notifyErrorByEmail = (
  error,
  { source = "app", fatal = false, params = {} } = {}
) => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
    return;
  }

  if (shouldThrottle(source, error)) {
    return;
  }

  emailjs
    .send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        from_name: "Portfolio site",
        from_email: cvData.profile.email,
        reply_to: cvData.profile.email,
        message: buildMessage(error, { source, fatal, params }),
        subject: `[Portfolio Error] ${source}`,
      },
      { publicKey: EMAILJS_PUBLIC_KEY }
    )
    .catch((sendError) => {
      devError("[Monitoring] Could not email the error alert", sendError);
    });
};
